import React from 'react'

export default class IconsDnDErrorMessageHolder extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M14.4867 12L9.15335 2.66665C9.03706 2.46146 8.86842 2.29078 8.66463 2.17203C8.46084 2.05329 8.22921 1.99072 7.99335 1.99072C7.75749 1.99072 7.52585 2.05329 7.32206 2.17203C7.11828 2.29078 6.94964 2.46146 6.83335 2.66665L1.50001 12C1.38247 12.2036 1.32083 12.4346 1.32135 12.6697C1.32187 12.9047 1.38453 13.1355 1.50298 13.3385C1.62142 13.5416 1.79145 13.7097 1.99581 13.8259C2.20018 13.942 2.43162 14.0021 2.66668 14H13.3333C13.5673 13.9997 13.797 13.938 13.9995 13.8208C14.202 13.7037 14.3702 13.5354 14.487 13.3327C14.6039 13.1301 14.6654 12.9002 14.6653 12.6663C14.6653 12.4324 14.6036 12.2026 14.4867 12Z'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path d='M8 6V8.66667' stroke='black' strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
                <path
                    d='M8 11.3333H8.00667'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
